module.exports = __webpack_public_path__ + "static/media/icon-supplies-qtips.3a918652.svg";